import Axios from 'axios';

class DeliveryAddressApi {

    constructor() {
        this.api = Axios.create({
            baseURL: '/api/DeliveryAddress'
        });
        this.customerRegApi = Axios.create({
            baseURL: '/api/CustomerRegistration'
        });
    };

    createDeliveryAddress(param) {
        return this.api.post('/CreateDeliveryAddressAsync', param);
    };
 

    listDeliveryAddresses() {
        return this.api.get('/ListDeliveryAddressesAsync');
    };

    getDeliveryAddress(id) {
        return this.api.get('/GetDeliveryAddressAsync', { params: { ekstraLeveringsAdresseId: id } });
    };

    getCurrentDeliveryAddress() {
        return this.api.get('/GetCurrentDeliveryAddressAsync' );
    };

    isDeliveryPhoneMandatory() {
        return this.api.get('/IsDeliveryPhoneMandatory');
    };

    isDeliveryEmailMandatory() {
        return this.api.get('/IsDeliveryEmailMandatory');
    };

    removeDeliveryAddress(id) {
        return this.api.post('/RemoveDeliveryAddressAsync', { EkstraLeveringsAdresseId: id });
    };
    setSelectedDeliveryAddress(id) {
        return this.api.post('/SelectDeliveryAddressAsync', { EkstraLeveringsAdresseId: id });
    };

    listCountries() {
        return this.api.get('/ListCountriesAsync');
    };
    getCountry() { 
        return this.api.get('/GetCurrentCountry');
    };

    getCity(postCode, countryId) {
        return this.api.get('/GetPoststedByPostNr', {
            params: {
                postcode: postCode,
                countryId: countryId
            }
        });
    };

    updateCartAttention(addressId, attention) {
        try {
            return this.api.post('/UpdateAttention', { EkstraLeveringsAdresseId: addressId, Attention: attention });
        } catch (error) {
            console.error('Error updating attention:', error);
            throw error;
        }
    };

    updateCartEmail(addressId, email) {
        try {
            return this.api.post('/UpdateCartEmail', { EkstraLeveringsAdresseId: addressId, Email: email });
        } catch (error) {
            console.error('Error updating email:', error);
            throw error;
        }
    };

    updateCartDeliveryAddressContactDetails(currentAddress) {
        try {
            return this.api.post('/UpdateCartDeliveryAddressContactDetails',
                {
                    EkstraLeveringsAdresseId: currentAddress.EkstraLeveringsAdresseId,
                    Email: currentAddress.Email,
                    Mobile: currentAddress.MobilePhone,
                    Attention: currentAddress.Attention
                });
        } catch (error) {
            console.error('Error updating email:', error);
            throw error;
        }
    };

    updateCartMobilePhone(addressId, mobile) {
        try {
            return this.api.post('/UpdateCartMobilePhone', { EkstraLeveringsAdresseId: addressId, Mobile: mobile });
        } catch (error) {
            console.error('Error updating mobile:', error);
            throw error;
        }
    };
}

export default new DeliveryAddressApi();